export default __webpack_public_path__ + "static/media/welcomepic.80cdf41a.png";